<template>
  <div class="photos">
    <!-- 必填证据 -->
    <div
      v-if="otherPhotoList.length == 0"
      v-for="(photo, index) in requiredPhotoList"
      :key="index"
      class="photo-wrapper1"
    >
      <div class="required-name1">
        {{ photo.photoName }}
      </div>
      <div>
        <img
          class="el-icon-close delete-photo"
          @click="deletePhoto(photo.photoUrl)"
          src="@/assets/images/accident/delete.png"
        />
        <el-image
          :key="photo.photoUrl"
          class="accident-image"
          :src="photo.photoUrl"
          :preview-src-list="previewSrcList"
        >
          <template #error>
            <div
              v-loading="photo.photoUrl === ''"
              :style="{
                cursor: isDisabled.value ? 'not-allowed' : 'pointer'
              }"
              class="required-upload"
              @click="addPhoto(photo.photoName)"
            >
              点击拍照截图
            </div>
          </template>
        </el-image>
      </div>
    </div>
    <!-- 其他证据 -->
    <div
      v-for="photo in otherPhotoList"
      :key="photo.photoUrl"
      class="photo-wrapper1"
    >
      <div class="required-name1">
        {{ photo.photoName }}
      </div>
      <div>
        <img
          class="el-icon-close delete-photo"
          @click="deletePhoto(photo.photoUrl)"
          src="@/assets/images/accident/delete.png"
        />
        <el-image
          class="accident-image"
          :src="photo.photoUrl"
          :preview-src-list="previewSrcList"
        >
          <template #error>
            <div
              class="capture1"
              :style="{
                cursor: isDisabled.value ? 'not-allowed' : 'pointer'
              }"
            >
              <i class="el-icon-loading" style="font-size: 22px" />
            </div>
          </template>
        </el-image>
      </div>
    </div>
    <div>
      <div
        class="capture1"
        :style="{ cursor: isDisabled.value ? 'not-allowed' : 'pointer' }"
        @click="addPhoto('其他照片')"
      >
        点击拍照截图
      </div>
    </div>
  </div>
</template>

<script>
import { upload } from "@/api/common/upload";
const requiredName = ["侧前方", "侧后方", "碰撞部位"];
export default {
  inject: {
    targetRefs: { default: null },
    isDisabled: { default: () => ({ value: false }) }
  },
  props: {
    accidentPhotoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeName: "",
      photoTypes: []
    };
  },
  computed: {
    currentPhotoList() {
      return this.accidentPhotoList.filter(
        ({ type }) => type == this.activeName
      );
    },
    requiredPhotoList() {
      return requiredName.map(
        name =>
          this.currentPhotoList.find(({ photoName }) => photoName === name) || {
            photoName: name,
            photoUrl: null
          }
      );
    },
    otherPhotoList() {
      return this.currentPhotoList.filter(
        item => !this.requiredPhotoList.includes(item)
      );
    },
    previewSrcList() {
      return this.currentPhotoList.map(({ photoUrl }) => photoUrl);
    }
  },
  created() {
    this.getPhotoTypes();
  },
  methods: {
    getPhotoTypes() {
      this.getDicts("accident_photo_type").then(({ data }) => {
        this.photoTypes = data;
        this.activeName = (data[0] || {}).dictValue;
      });
    },
    addPhoto(photoName = "新增图片") {
      if (this.isDisabled.value) {
        return;
      }
      if (this.accidentPhotoList.length >= 50) {
        this.$message.warning("截图数量达到上限");
        return;
      }
      const newPhoto = {
        photoUrl: "",
        photoName,
        type: this.activeName
      };
      this.accidentPhotoList.push(newPhoto);
      console.log('addPhoto,video:{}', this.targetRefs.video)
      this.targetRefs.video
        .screenShot()
        .then(base64Str => upload({ fileName: "xxx.png", base64Str }))
        .then(({ data }) => (newPhoto.photoUrl = data))
        .catch(() => {
          this.accidentPhotoList.splice(
            this.accidentPhotoList.findIndex(item => item === newPhoto),
            1
          );
        });
    },
    deletePhoto(url) {
      this.accidentPhotoList.splice(
        this.accidentPhotoList.findIndex(({ photoUrl }) => photoUrl === url),
        1
      );
    }
  }
};
</script>

<style lang="scss">
.photos {
  width: 1000px;
  height: 450px;
  overflow: auto;
  border: none;
  padding: 65px 10px 0 20px;
  background: transparent;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  &::-webkit-scrollbar {
    /*定义滚动条高宽及背景
    高宽分别对应横竖滚动条的尺寸*/
    width: 0px;
    background-color: #f5f5f5;
  }
  .el-tabs__header {
    margin-bottom: 10px;
  }

  .photo-wrapper1 {
    position: relative;
    width: 220px;
    height: 140px;
    margin: 0 50px 40px;
    background: #0b2756;
    .accident-image {
      width: 100%;
      height: 140px;
      border-radius: 2px;
      .required-upload {
        background: rgba(0, 0, 0, 0.04);
        font-size: 16px;
        color: #17ecfe;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
    .required-name1 {
      position: absolute;
      left: -28px;
      height: 100%;
      font-size: 12px;
      font-weight: 400;
      text-align: center;
      color: #17ecfe;
      letter-spacing: 1px;
      writing-mode: tb-rl;
    }
    .photo-name-input {
      .el-input__inner {
        border: none;
        padding: 0;
        text-align: center;
        cursor: default;

        &:focus {
          border: 1px solid #020202;
          cursor: text;
        }
      }
    }

    .delete-photo {
      cursor: pointer;
      display: none;
      position: absolute;
      right: 5px;
      top: 5px;
      font-weight: 500;
      font-size: 22px;
      z-index: 10;
      color: #ff4949;
    }
    position: relative;

    &:hover {
      .delete-photo {
        display: block;
      }
    }
  }
  .capture1 {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 220px;
    height: 140px;
    margin: 0 50px 40px;
    background: #0b2756;
    border-radius: 2px;
    font-size: 16px;
    font-weight: 400;
    color: #17ecfe;
  }
}
</style>
